var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arrow-box flex flex-ali-center flex-center",style:(_vm.style)},[_c('div',{staticClass:"arrow-bottom",style:(_vm.arrowStyle)}),_c('div',{staticClass:"center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }